import { wealthProApi } from '../../redux/api';

const clientServiceLevelAgreementStatusEndpoints = wealthProApi.injectEndpoints({
    endpoints: (builder) => ({ 
        fetchClientServiceLevelAgreementStatusesList: builder.query({
            query: ({ cslaId }) => `/api/review/clientservicelevelagreementstatuses/${cslaId}/status/list`
        })
    })
});

export const {
    useFetchClientServiceLevelAgreementStatusesListQuery,
    useLazyFetchClientServiceLevelAgreementStatusesListQuery
} = clientServiceLevelAgreementStatusEndpoints;